import { Chance } from "chance"
import { Laboratory } from "etl/types";

const chance = new Chance();

export const laboratoryFactoryMock = (howMany: number): Laboratory[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/laboratories/${index + 1}`,
		id: index + 1,
		label: chance.company(),
	}));
